import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconClose';
/** Renders an SVG icon. */
const SvgClose = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.293 5.293a1 1 0 0 1 1.414 0L16 14.586l9.293-9.293a1 1 0 1 1 1.414 1.414L17.414 16l9.293 9.293a1 1 0 0 1-1.414 1.414L16 17.414l-9.293 9.293a1 1 0 0 1-1.414-1.414L14.586 16 5.293 6.707a1 1 0 0 1 0-1.414"
      />
    </svg>
  );
};
SvgClose.displayName = displayName;
export default SvgClose;
